import { FunnelImage, FunnelSprite } from './MediaData';

export const VisualAssetType = {
  IMAGE: 'image',
  SPRITE: 'sprite',
  ANIMATION: 'animation',
} as const;

type ImageVisualAsset = FunnelImage & {
  type?: typeof VisualAssetType.IMAGE;
};

type SpriteVisualAsset = FunnelSprite & {
  type: typeof VisualAssetType.SPRITE;
};

type AnimationVisualAsset = {
  type: typeof VisualAssetType.ANIMATION;
  url: string;
  loop?: boolean;
  width?: number;
  height?: number;
};

export type VisualAsset = ImageVisualAsset | SpriteVisualAsset | AnimationVisualAsset;
